var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdministration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M16.1123 8.91015L13.8357 11.1867L14.1427 12.7213L15.6772 13.0282L17.9538 10.7516L17.954 10.7515C18.2358 11.4167 18.3032 12.1531 18.1468 12.8584C17.9904 13.5637 17.618 14.2026 17.0815 14.6863C16.545 15.1701 15.871 15.4745 15.1533 15.5572C14.4357 15.6399 13.7101 15.4968 13.0776 15.1479L13.0777 15.1478L10.0348 18.6706C9.79055 18.9145 9.45943 19.0515 9.11422 19.0514C8.76901 19.0513 8.43797 18.9142 8.19387 18.6701C7.94978 18.426 7.8126 18.0949 7.8125 17.7497C7.8124 17.4045 7.94939 17.0734 8.19335 16.8291L11.7161 13.7863L11.7161 13.7863C11.3671 13.1538 11.224 12.4282 11.3067 11.7106C11.3895 10.993 11.6939 10.319 12.1776 9.78242C12.6613 9.24589 13.3003 8.87351 14.0055 8.71713C14.7108 8.56075 15.4473 8.62815 16.1124 8.90993L16.1123 8.91015Z",
    stroke: "#1C1C1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.98678 12.1485C6.91356 11.9459 5.32122 12.1475 4.18682 12.5349C3.05242 12.9224 2.24695 13.5045 1.92553 14.1692C1.60411 14.8338 1.78948 15.534 2.44593 16.1348C3.10239 16.7357 4.1835 17.1947 5.48107 17.4236",
    stroke: "#1C1C1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 7.81211,
    cy: 5.09922,
    r: 3.65,
    stroke: "#1C1C1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.217cf6da3d3ea5d3a02111dccae242c9.svg";
export { ForwardRef as ReactComponent };